import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    IconButton,
    Divider,
    Stack,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import CloseIcon from "@mui/icons-material/Close";
import { format, parseISO } from "date-fns";

export default function PreviewEmailTaskDialog({ open, onClose, email }) {
    if (!email) return null;

    const sentAt = email.sent_at
        ? format(parseISO(email.sent_at), "MMM d, yyyy h:mm a")
        : null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ pr: 1, pb: 1 }}>
                <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
                        <EmailIcon color="action" sx={{ flexShrink: 0, mt: 0.25 }} />
                        <Typography
                            variant="subtitle1"
                            sx={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, lineHeight: 1.3 }}
                        >
                            {email.subject || "(No Subject)"}
                        </Typography>
                    </Stack>
                    <IconButton size="small" onClick={onClose} sx={{ flexShrink: 0 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ pt: 2 }}>
                <Stack spacing={0.25} sx={{ mb: 2 }}>
                    <Stack direction="row" spacing={0.5}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, minWidth: 36 }}>
                            From:
                        </Typography>
                        <Typography variant="caption" sx={{ fontFamily: "Montserrat, sans-serif" }}>
                            {email.from_email}
                        </Typography>
                    </Stack>
                    {sentAt && (
                        <Stack direction="row" spacing={0.5}>
                            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, minWidth: 36 }}>
                                Date:
                            </Typography>
                            <Typography variant="caption" sx={{ fontFamily: "Montserrat, sans-serif" }}>
                                {sentAt}
                            </Typography>
                        </Stack>
                    )}
                </Stack>

                <Divider sx={{ mb: 2 }} />

                {email.body_text ? (
                    <Box
                        sx={{
                            whiteSpace: "pre-wrap",
                            fontFamily: "monospace",
                            fontSize: "0.8rem",
                            lineHeight: 1.6,
                            color: "text.primary",
                            bgcolor: "action.hover",
                            borderRadius: 1,
                            p: 1.5,
                            maxHeight: 400,
                            overflowY: "auto",
                        }}
                    >
                        {email.body_text}
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "Montserrat, sans-serif", textAlign: "center", py: 3 }}>
                        No message body
                    </Typography>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
